(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* javascript */
  document.addEventListener("DOMContentLoaded", function() {

    const getCart = async function(){
      const response = await fetch('/cart.js');
      return  await response.json();
    };

    const loadRecommendedProducts = async function () {

      console.log( '..loading products' );

      const cart = await getCart();

      let productID = null;

      if(cart.items && cart.items.length){

        productID = cart.items[0].product_id;
      }else{
        return false;
      }

      let productRecommendationsSection = document.querySelectorAll('.product-recommendations');

      // const url = productRecommendationsSection.dataset.url;
      const url = Shopify.routes.product_recommendations + '/?section_id=cart-recommendations&product_id=' + productID + '&limit=10&intent=related';

      fetch(url)
              .then(response => response.text())
              .then(text => {

                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {

                  productRecommendationsSection.forEach( function(el){

                    el.innerHTML = recommendations.innerHTML;
                  } );

                }

              })
              .catch(e => {
                console.error(e);
              });
    };


    window.addEventListener('theme:cart:updated', function () {
      loadRecommendedProducts();
    });

      loadRecommendedProducts();

  });



  } catch(e) { console.error(e); }
})();
})();
